import { render, staticRenderFns } from "./veStuAssoc.vue?vue&type=template&id=04abb084&scoped=true"
import script from "./veStuAssoc.vue?vue&type=script&lang=js"
export * from "./veStuAssoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04abb084",
  null
  
)

export default component.exports